import React, { useEffect, useState } from "react";
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'
import FileViewer from "react-file-viewer";
import * as XLSX from 'xlsx';


const ReactFileViewer = (props: any) => {

  const [XLSData,setXLSData] = useState<any>(null);

  const viewFile = () => {
    if (props?.fileDocument?.data) {
      const arr = [props?.fileDocument]
      return arr
    }
    else {
      const obj = {
        ...props?.fileDocument,
        uri: `data:application/pdf;base64,${props?.fileDocument.uri}`
      }
      const arr = [obj]
      return arr
    }
  }
  const decodeBase64 = (base64: string) => {
    const binaryString = window.atob(base64);
    const len = binaryString?.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  };
  
  const parseXLSX = (data: Uint8Array) => {
    const workbook = XLSX.read(data, { type: 'array' });
    const firstSheetName = workbook?.SheetNames?.[0];
    const worksheet = workbook.Sheets[firstSheetName];
    return XLSX.utils.sheet_to_json(worksheet);
  };

  useEffect(() => {
    if (props.fileDocument?.fileType === 'xls'  || props.fileDocument?.fileType === 'xlsx') {
      const bytes = decodeBase64(props?.fileDocument?.uri);
      const json = parseXLSX(bytes);
      setXLSData(json);
    }
  }, [props.fileDocument]);

  return (
    <>
      {props?.fileDocument?.fileType == "pdf" ?
      <>
      {viewFile().length > 0 &&
        <DocViewer
          documents={viewFile()}
          pluginRenderers={DocViewerRenderers}
          config={{
            header: {
              disableHeader: true,
              disableFileName: false,
              retainURLParams: false,
            }

          }}
        />}
        </>
        :
        props?.fileDocument?.fileType === "xls" || props.fileDocument?.fileType === 'xlsx'? (
          <div className="xls-table">
            <table>
              <thead>
                <tr>
                  {XLSData && Object.keys(XLSData?.[0]).map((key, index) => (
                    <th key={index}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {XLSData && XLSData?.map((row:any, index:any) => (
                  <tr key={index}>
                   {Object.values(row as Record<string, any>).map((value, idx) => (
                      <td key={idx}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ):
        props.fileDocument?.data ?
          <FileViewer
            fileType={props.fileDocument?.fileType}
            filePath={props.fileDocument?.data}
          />
          :
          <FileViewer
            fileType={props.fileDocument?.fileType}
            filePath={`data:application/${props.fileDocument?.fileType};base64,${props.fileDocument?.uri}`}
          />
      }
    </>
  )
};

export default ReactFileViewer;
